var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ROTATION_OFFSET = 0;
var ENUM_IDLE = -1;
var ANIMATION_SPEED = 1.5;
var ANIMATIONS = {
    Attack: [
        {
            angle: Phaser.Math.RadToDeg(-1 * (Math.PI / 4) + ROTATION_OFFSET),
            comparison: 1, // if rotation is larger
            increase: Phaser.Math.RadToDeg((ANIMATION_SPEED * -1 * Math.PI) / 32),
        },
        {
            angle: Phaser.Math.RadToDeg(3 * (Math.PI / 16) + ROTATION_OFFSET),
            comparison: -1, // if rotation is smaller
            increase: Phaser.Math.RadToDeg((ANIMATION_SPEED * Math.PI) / 16),
        },
        {
            angle: Phaser.Math.RadToDeg(ROTATION_OFFSET),
            comparison: 1, // if rotation is larger
            increase: Phaser.Math.RadToDeg((ANIMATION_SPEED * -1 * Math.PI) / 16),
        },
    ],
};
var SIZE = {
    width: 500,
    height: 1200,
};
var Weapon = /** @class */ (function (_super) {
    __extends(Weapon, _super);
    function Weapon(scene, data) {
        var _this = _super.call(this, scene, 0, 50) || this;
        _this.animationFrame = ENUM_IDLE;
        _this.image = new Phaser.Physics.Arcade.Sprite(scene, 500, 350, "weapon_" + data.game.level, 0);
        _this.scene.physics.world.enable(_this.image);
        _this.image.setImmovable(true);
        _this.image.setCollideWorldBounds(false);
        _this._scaleImage();
        _this.setScale(0.8);
        _this.add(_this.image);
        return _this;
    }
    Weapon.prototype._scaleImage = function () {
        this.image.setScale(SIZE.width / this.image.width, SIZE.height / this.image.height);
    };
    Weapon.prototype.getBody = function () {
        return this.image;
    };
    Weapon.prototype.getAnimationStatus = function () {
        return this.animationFrame != ENUM_IDLE;
    };
    Weapon.prototype.setLevel = function (level) {
        this.image.setTexture("weapon_" + level);
        this._scaleImage();
    };
    Weapon.prototype.attack = function (callback) {
        if (this.animationFrame != -1)
            return;
        this.animationFrame = 0;
        callback && callback();
    };
    Weapon.prototype.attackAnimation = function () {
        if (this.animationFrame == -1)
            return;
        var animationFrameRule = ANIMATIONS.Attack[this.animationFrame];
        if (!animationFrameRule) {
            this.animationFrame = -1;
            return;
        }
        switch (animationFrameRule.comparison) {
            case -1:
                this.angle < animationFrameRule.angle
                    ? (this.angle += animationFrameRule.increase)
                    : this.animationFrame++;
                break;
            case 0:
                this.angle == animationFrameRule.angle
                    ? (this.angle += animationFrameRule.increase)
                    : this.animationFrame++;
                break;
            case 1:
                this.angle > animationFrameRule.angle
                    ? (this.angle += animationFrameRule.increase)
                    : this.animationFrame++;
                break;
            default:
                break;
        }
    };
    return Weapon;
}(Phaser.GameObjects.Container));
export default Weapon;
